import TestimonialCard from './TestimonialCard';

const testimonials = [
  {
    name: 'Wesley Correa',
    role: 'Oficial de Justiça',
    image: 'https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/32ce8e16-bf86-4bf3-1609-93f79fb5ef00/public',
    alt: 'IA para advogados',
    quote: 'A LawX transformou a maneira como realizamos pesquisas jurídicas. O que antes levava dias agora leva horas.',
    rating: 5,
    metric: 'pesquisa jurídica 3x mais rápida'
  },
  {
    name: 'Jéssica Natasha',
    role: 'Advogada',
    image: 'https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/d6f5439f-9168-4e84-3c0e-d244ab8aac00/public',
    alt: 'IA para advogados',
    quote: 'Com as ferramentas personalizadas da LawX, consigo terminar minhas peças em minutos.',
    rating: 5,
    metric: '+20 horas economizadas semanalmente'
  },
  {
    name: 'Gustavo Lagranha',
    role: 'CEO Blue Lobster',
    image: 'https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/8a54705e-894b-4b8e-fe4f-758f6fad4300/public',
    alt: 'IA para advogados',
    quote: 'Implementar a LawX foi a melhor decisão que tomamos para a transformação digital da nossa firma.',
    rating: 5,
    metric: 'custos reduzidos em 45%'
  }
];

export default function Testimonials() {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute -right-40 top-0 w-[500px] h-[500px] rounded-full bg-[#28E7C5] opacity-10 blur-3xl" />
      
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">O que nossos clientes dizem?</h2>
          <p className="text-xl text-gray-300">
            Junte-se a 50.000+ advogados que estão transformando sua prática jurídica com a LawX
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}
